import loginModel from './login.model';
import modelBaseV2 from './model-base-v2.model';

const updateCredentialsFromProfile = (result) => {
  loginModel.credentials.userID = result.userID;
  loginModel.credentials.username = result.userName;
  loginModel.credentials.country = result.countryCode;
  loginModel.credentials.roleCode = result.userRoleCode;
  loginModel.credentials.language = result.languageCode;
  loginModel.credentials.languageName = result.languageName;
  loginModel.credentials.admin = result.adminYN == 'Y';
  loginModel.credentials.userFunctionUserRole = result.userFunctionRoleCode;
  loginModel.credentials.subsidiaryCode = result.subsidiaryCode;
  loginModel.profileDetails = result;
  // Persist final values
  loginModel.setCountry(loginModel.credentials.country);
  loginModel.setLanguage(loginModel.credentials.language, loginModel.credentials.languageName);
};

var profileModel = {
  getProfile: (params) => {
    return modelBaseV2.get('/api/user/userprofile', params)
      .then((result) => {
        updateCredentialsFromProfile(result);
        return result;
      });
  },
  switchCountry: (countryCode) => {
    const params = {
      countryCode
    };
    return modelBaseV2.get('/api/user/switch-country/:countryCode', { params })
      .then(() => {
        loginModel.setCountry(params.countryCode);
      });
  },
  switchLanguage: (language) => {
    const params = {
      languageCode: language.fullCode
    };
    return modelBaseV2.get('/api/user/switch-language/:languageCode', { params })
      .then(() => {
        loginModel.setLanguage(language.code, language.name);
      });
  }
}

export const getHelpDeskInfo = () => {
  return modelBaseV2.get('/api/menu/helpdesk', {}, true);
}

export default profileModel;